import {
  IIntermediateTransactionInfo,
  transactionKlassType,
  transactionStatusType,
} from './../reducers/transactions';
import { IIntermediateTransaction } from '../reducers/transactions';
import { ELROND_CHAIN_ID, TON_CHAIN_ID } from './customChains';

const getKlassForChain = (chainId: number): transactionKlassType => {
  switch (chainId) {
  case ELROND_CHAIN_ID:
    return 'Elrond';
  case TON_CHAIN_ID:
    return 'Ton';
  default:
    return 'EVM';
  }
};

export const toIntermediateTransaction = (
  tx: string,
  chainId: number,
  isTrading?: boolean
): IIntermediateTransaction => ({
  klass: getKlassForChain(chainId),
  chainId,
  trading: !!isTrading,
  description: isTrading ? 'Swap' : 'Approval',
  tx,
});

export const toIntermediateTransactionInfo = (
  status: transactionStatusType
): IIntermediateTransactionInfo => ({
  status,
  lastUpdate: Number(new Date()),
});
